import { render } from "./IconGeneric.vue?vue&type=template&id=5f961e9e"
import script from "./IconGeneric.vue?vue&type=script&lang=js"
export * from "./IconGeneric.vue?vue&type=script&lang=js"

import "./IconGeneric.vue?vue&type=style&index=0&id=5f961e9e&lang=scss"

import exportComponent from "D:\\perso\\miam\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__